import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate} from 'react-router-dom';
import {setModalAC} from 'store/modal/modalSlice';
import './LogoutConfirmation.scss';

const LogoutConfirmation = () => {
  const navigate = useNavigate();
  const dispatch = useSetGlobalState();

  const handleClose = () => dispatch(setModalAC(null));

  const handleLogout = () => {
    localStorage.clear();
    navigate(Routes.LOGIN);
    handleClose();
  };

  return (
    <div className="logout-confirmation">
      <div className="logout-confirmation__icon">
        <Icon icon="logout_confirmation" />
      </div>
      <Text className="logout-confirmation__title" tag="h3">
        Beer Break Time?
      </Text>
      <Text className="logout-confirmation__description" tag="p">
        By logging out, you&apos;re signing off for now. Remember, the best brews are yet to be tasted.
      </Text>
      <div className="logout-confirmation__actions">
        <Button variant="text" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
